import { Role } from "utils";


import {
  HomePage,
  ProfilePage,
  PreviewPage,
  UserProfilePage,
  UsersPage,
  UsersV2,
  CaregiversPage,
  CareHomesPage,
  CareCirclesPage,
  SocialCirclesPage,
  SkillCirclesPage,
  LJPage,
  CreateLJPage,
  EditLJPage,
  StepsPage,
  EditStepPage,
  DataContentPage,
  CreateContentPage,
  EditContentPage,
  ResourcesPage,
  ResourcesDiscoverPage,
  CreateResourcePage,
  EditResourcePage,
  DashboardThriversPage,
  DashboardCaregiverPage,
  DashboardMoodPage,
  DashboardEngagementPage,
  DashboardHealthCheckPage,
  DashboardHealthDetailPage,
  DashboardSmartWatchPage,
  DashboardSmartWatchGraphPage,
  DashboardActivityLogPage,
  DashboardDailyAnalyticsPage,
  DashboardSensorActivityInsightsPage,
  DashboardActivityLogDetailsPage,
  ThrivingAIAnalyticsPage,
  CalendarPage,
  CalendarCreatePage,
  CalendarEditPage,
  CalendarEventsPage,
  RecordsPage,
  IoTPage,
  IoTLinkPage,
  IoTEditPage,
  IoTLocationsPage,
  ReportsPage,
  VersionControlPage,
  CustomerJourneyPage,
  GuidesPage,
  CarePlanPage,
  ChatnelsMoodPage,
  ChatnelsDetailPage,
  ZinniaPage,
  EditZinniaPage,
  CreateZinniaPage,
  DashboardStressIndexPage,
  DashboardStressUserScorePage,
  CaregiverPreviewPage,
  DashboardMonthlyHealthCheckAnalytics,
  SupportListingPage,
  DashboardSummary,
  CareFacilityPage,
  CreateCareFacilityPage,
  CareFacilityDetailPage,
  SocialCircleEventsPage,
  SocialCircleEventsDetailPage,
  CreateSocialCircleEventsPage,
  LonelinessSurveyPage,
  WellbeingSurveyPage,
  PHQ9SurveyPage,
  SurveyUserDetailPage,
  SensorPage,
  GAD7SurveyPage,
  EQ5SurveyPage,
  CreateCareCircleChatPage,
  CreateCargiverChatPage,
  CreateCarehomeChatPage,
  SocialCircleFlagPage,
  CareHomePermissions,
  ArchivedCirclesPage,
  TrustSourcesPage,
  SubAdminsPage,
  DashboardBrainBoostPage,
  DashboardGameUserDetailsPage,
  CaregiversV2Page,
  CareHomesV2Page,
  AssignCareHomesPage,
  MyCareHomesPage,
  GlobalEventsPage,
  CreateGlobalEventPage,
  EditGlobalEventPage,
  GlobalEventDetailPage,
  DashboardRoomOccupancyPage
} from "./imports";
import UserDetails from "components/UsersView/subcomponents/UserDetails";

// Routes user can access based on its dashboard permissions

// Shared Routes (careHome, caregiver, admin)
const sharedRoutes = [
  { path: "/", name: "Home" },
  { path: "/home", name: "", component: HomePage },
  { path: "/profile", name: "Profile", component: ProfilePage },
  { path: "/user-profile", name: "User profile", component: UserProfilePage },
  { path: "/users", name: "Users new", component: UsersV2 },
  {path: "/users-old",name: "Users",component: UsersPage},
  { path: "/user-preview", name: "User Preview", component: PreviewPage },
  { path: "/users-detail", name: "Users Detail", component: CaregiverPreviewPage },
  { path: "/care-circles", name: "Care Circles", component: CareCirclesPage },
  {path: "/CareCircle-chat", name:"CareCirclechat page", component: CreateCareCircleChatPage},
  {path: "/Caregiverchat", name:"CaregiverChat page", component: CreateCargiverChatPage},
  {path: "/Carehomechat", name:"CarehomeChat page", component: CreateCarehomeChatPage},
  { path: "/care-circles", name: "Care Circles", component: CareCirclesPage },
  // Dashboards
  {
    path: "/dashboard/thrivers",
    name: "Analytics Per Thriver",
    component: DashboardThriversPage,
  },
  {
    path: "/dashboard-summary",
    name: "Dashboard Summary",
    component: DashboardSummary,
  },
  {
    path: "/dashboard/monthly-healthCheck/:month/:category",
    name: "Monthly Health Check Analytics",
    component: DashboardMonthlyHealthCheckAnalytics,
  },
  {
    path: "/dashboard/mood",
    name: "Mood Analytics",
    component: DashboardMoodPage,
  },
  {
    path: "/dashboard/engagement",
    name: "Engagement Analytics",
    component: DashboardEngagementPage,
  },
  {
    path: "/dashboard/health-check",
    name: "Health Check",
    component: DashboardHealthCheckPage,
  },
  {
    path: "/dashboard/health-check/details",
    name: "Health Check Details",
    component: DashboardHealthDetailPage,
  },
  {
    path: "/dashboard/smart-watch",
    name: "Smart Watch Analytics",
    component: DashboardSmartWatchPage,
  },
  {
    path: "/dashboard/smart-watch/graph",
    name: "Smart Watch graph",
    component: DashboardSmartWatchGraphPage,
  },
  {
    path: "/dashboard/activity-log",
    name: "Activity Log",
    component: DashboardActivityLogPage,
  },
  {
    path: "/dashboard/SmartThingSensorInsights",
    name: "SmartThing Sensor Insights",
    component: DashboardDailyAnalyticsPage,
  },
  {
    path: "/dashboard/sensor-activity-insights",
    name: "Sensor Activity Insights",
    component: DashboardSensorActivityInsightsPage,
  },
  {
    path: "/dashboard/room-occupancy",
    name: "Room Occupancy",
    component: DashboardRoomOccupancyPage,
  },
  {
    path: "/dashboard/activity-log/details",
    name: "Activity Log Detail",
    component: DashboardActivityLogDetailsPage,
  },
  {
    path: "/dashboard/chatnels-mood",
    name: "Chatnels mood analytics",
    component: ChatnelsMoodPage,
  },
  {
    path: "/dashboard/chatnels-mood/details",
    name: "Chatnels mood analytics",
    component: ChatnelsDetailPage,
  },
  {
    path: "/dashboard/stress-index",
    name: "Stress Index",
    component: DashboardStressIndexPage,
  },
  {
    path: "/dashboard/stress-user-score",
    name: "Stress User Score",
    component: DashboardStressUserScorePage,
  },
  {
    path: "/dashboard/brain-boost",
    name: "Brain Boost Activity",
    component: DashboardBrainBoostPage,
  },
  // Guides 
  {
    path: "/guides",
    name: "Guides",
    component: GuidesPage,
  },
];

// Routes for careHomeAdmin and superAdmin
const sharedAdminRoutes = [
  ...sharedRoutes,
  { path: "/caregivers-old", name: "Caregivers", component: CaregiversPage },
  { path: "/caregivers", name: "Caregivers", component: CaregiversV2Page },
  // Content space
  { path: "/resources", name: "Resources", component: ResourcesPage },
  {
    path: "/resources/create",
    name: "Create Resource",
    component: CreateResourcePage,
  },
  {
    path: "/resources/edit/:id",
    name: "Edit Resource",
    component: EditResourcePage,
  },
  { path: "/learning-journeys", name: "Learning Journeys", component: LJPage },
  { path: "/learning-journeys/create", name: "Create Learning Journey", component: CreateLJPage },
  { path: "/learning-journeys/edit/:id", name: "Edit Learning Journey", component: EditLJPage },
  { path: "/learning-journeys/steps/:id", name: "Steps", component: StepsPage },
  { path: "/learning-journeys/step-edit/:idLJ/:idST", name: "Edit Step", component: EditStepPage },

  { path: "/care-facility", name: "Care facility", component: CareFacilityPage },
  { path: "/care-facility/create", name: "Create Care facility", component: CreateCareFacilityPage },
  { path: "/care-facility/edit/:id", name: "Edit Care facility", component: CreateCareFacilityPage },
  { path: "/care-facility/detail/:id", name: "Care facility Detail", component: CareFacilityDetailPage },

  { path: "/social-circle-events", name: "Care facility", component: SocialCircleEventsPage },
  { path: "/social-circle-events/create", name: "Create Care facility", component: CreateSocialCircleEventsPage },
  { path: "/social-circle-events/edit/:id", name: "Edit Care facility", component: CreateSocialCircleEventsPage },
  { path: "/social-circle-events/detail/:id", name: "Care facility Detail", component: SocialCircleEventsDetailPage },

  { path: "/zinnia", name: "Zinnia", component: ZinniaPage },
  {
    path: "/zinnia/create",
    name: "Create Resource",
    component: CreateZinniaPage,
  }, {
    path: "/zinnia/edit/:id",
    name: "Edit Resource",
    component: EditZinniaPage,
  },
  // Content space
  { path: "/content", name: "Content", component: DataContentPage },
  {
    path: "/content/create",
    name: "Create Content",
    component: CreateContentPage,
  },
  {
    path: "/content/edit/:id",
    name: "Edit Content",
    component: EditContentPage,
  },
  // Dashboard
  {
    path: "/dashboard/caregivers",
    name: "Analytics Per Caregiver",
    component: DashboardCaregiverPage,
  },
  // Skill circles
  {
    path: "/skill-circles",
    name: "Skill Circles",
    component: SkillCirclesPage,
  },
  {
    path: "/support-tickets",
    name: "Support Tickets",
    component: SupportListingPage,
  },
  {
    path: "/loneliness-survey",
    name: "Loneliness Survey",
    component: LonelinessSurveyPage,
  },

  {
    path: "/wellbeing-survey",
    name: "Wellbeing Survey",
    component: WellbeingSurveyPage,
  },
  {
    path: "/phq-survey",
    name: "PHQ9 Survey",
    component: PHQ9SurveyPage,
  },
  {
    path: "/gad-survey",
    name: "GAD7 Survey",
    component: GAD7SurveyPage,
  },
  {
    path: "/aq-survey",
    name: "EQ5 Survey",
    component: EQ5SurveyPage,
  },
  {
    path: "/survey-detail/user",
    name: "survey-detail",
    component: SurveyUserDetailPage,
  },
  {
    path: "/dashboard/users/:userId",
    name: "gamesActivity UserDetails",
    component: DashboardGameUserDetailsPage
  }
];

// SuperAdmin Routes
const adminRoutes = [
  { path: "/carehomes-old", name: "CareHomes", component: CareHomesPage },
  { path: "/carehomes", name: "CareHomes", component: CareHomesV2Page },
  {
    path: "/dashboard/thriving-ai",
    name: "Thriving.ai Analytics",
    component: ThrivingAIAnalyticsPage,
  },
  {
    path: "/b2b/care-home-permissions/:careHomeId",
    name: "Carehomepermissions",
    component: CareHomePermissions,
  },
  // Learning Journeys
  { path: "/learning-journeys", name: "Learning Journeys", component: LJPage },
  {
    path: "/learning-journeys/create",
    name: "Create",
    component: CreateLJPage,
  },
  {
    path: "/learning-journeys/edit/:id",
    name: "Edit",
    component: EditLJPage,
  },
  {
    path: "/learning-journeys/steps/:id",
    name: "Create Steps",
    component: StepsPage,
    exact: true,
  },
  {
    path: "/learning-journeys/step-edit/:idLJ/:idST",
    name: "Edit Step",
    component: EditStepPage,
    exact: true,
  },
  // Reports
  {
    path: "/reports",
    name: "Reports",
    component: ReportsPage,
  },
  // Version control
  {
    path: "/version-control",
    name: "Version Control",
    component: VersionControlPage,
  },
  {
    path: "/customer-journey",
    name: "Customer Journey",
    component: CustomerJourneyPage,
  },
  {
    path: "/social-circles",
    name: "Social Circles",
    component: SocialCirclesPage,
  },
  {
    path: "/archived-circles",
    name: "Archived Circles",
    component: ArchivedCirclesPage,
  },
  {
    path: "/social-circles/flag",
    name: "social-circle/flag",
    component: SocialCircleFlagPage,
  },
  {
    path: "/resources/discover",
    name: "Discover Resources",
    component: ResourcesDiscoverPage,
  },
  {
    path: "/trust-sources",
    name: "Trust Sources",
    component: TrustSourcesPage
  },
  {
    path: "/sub-admins",
    name: "Sub-Admins",
    component: SubAdminsPage,
  },
 {
  name:"Assign carehome",
  path:"/sub-admins/:subAdminId/care-homes",
  component:AssignCareHomesPage
 },
 {
  name: "My Care Homes",
  path: "/my-care-homes/:subAdminId",
  component: MyCareHomesPage,
},
{
  path: "/global-event",
  name: "Global Events",
  component: GlobalEventsPage,
},
{
  path: "/global-event/create",
  name: "Create Global Event",
  component: CreateGlobalEventPage,
},
{
  path: "/global-event/edit/:id",
  name: "Edit Global Event",
  component: EditGlobalEventPage,
},
{
  path: "/global-event/detail/:id",
  name: "Global Event Detail",
  component: GlobalEventDetailPage,
},
];

// CareHome Routes
const careHomeRoutes = [
  // Calendar
  { path: "/calendar", name: "Calendar", component: CalendarPage },
  { path: "/sensor", name: "Bed Sensor", component: SensorPage },
  {
    path: "/calendar/events",
    name: "Events",
    component: CalendarEventsPage,
  },
  {
    path: "/calendar/create",
    name: "Create Event",
    component: CalendarCreatePage,
  },
  {
    path: "/calendar/edit",
    name: "Edit Event",
    component: CalendarEditPage,
  },
  // Records
  {
    path: "/activity-record",
    name: "Caregivers Records",
    component: RecordsPage,
  },
  // Care plan
  {
    path: "/care-plan",
    name: "Care Plan",
    component: CarePlanPage,
  },
];

export const getRoutes = ({ location, viewAs }) => {
  setLocationRoutes(location);
  if (viewAs?.identifier) return [...sharedAdminRoutes];
  if (Role.careHomeAccess()) return [...sharedAdminRoutes, ...careHomeRoutes];
  if (Role.adminAccess()) return [...sharedAdminRoutes, ...adminRoutes];
  return [...sharedRoutes];
};

const setLocationRoutes = (location) => {
  // const isFromUK = location === "UK";

  // if (isFromUK) {
  sharedAdminRoutes.push(
    //Iot
    { path: "/iot", name: "Smart Devices", component: IoTPage },
    { path: "/iot/link", name: "Link Device", component: IoTLinkPage },
    { path: "/iot/edit/:id", name: "Edit Device", component: IoTEditPage },
    { path: "/iot/locations", name: "Locations", component: IoTLocationsPage }
  );
  // }
};
